import { styled } from "@givenwell/stitches";

export const Legend = styled("legend", {
  d: "block",
  fontScale: "sm",
  weight: 500,
});
